import { Link } from 'react-router-dom'

function Header({selection}) {
  const name = selection.length !== 0 ? selection[0].name : '제품보기';

  return (
    <div className="product__header-container">
      <div className="product__header-wrapper column">
        <div className="product__header-title">
          <h1>{name}</h1>
        </div>
        <div className="product__header-route">
          <p>
            <Link to="/"><span>홈</span></Link> / <Link to="/products"><span className="gray-text">제품 보기</span></Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Header;